// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"655":"95f89dcf","867":"2e4a2c2c"}[chunkId] + ".chunk.js";
};